import { User } from "../../../shared/entities/types";
import { useAuthStore } from "../store/useAuthStore";
import { generateDeviceFingerprint } from "../utils/generateDeviceFingerprint";

const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "https://localhost:5001";

export interface AuthSessionResponse {
  auth: true;
  token: string;
  user: User;
}

/**
 * Re-registers this device's fingerprint -> current JWT mapping so the
 * extension's "Discuss" button can find the right user. This has to run on
 * every committed session, not just the login form submit: most of the time
 * the dashboard is just rehydrating an already-valid JWT from localStorage
 * (no login request happens), and without this the extension keeps using
 * whatever session was registered last - or falls back to the demo account.
 */
function registerExtensionSession(token: string) {
  const fingerprint = generateDeviceFingerprint();
  fetch(`${API_BASE_URL}/api/store-extension-session`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ device_fingerprint: fingerprint }),
  }).catch((err) => {
    console.warn("Could not register extension session:", err);
  });
}

/** The only path for committing an authenticated server user to the client. */
export function applyAuthSession(session: AuthSessionResponse): User {
  const user: User = {
    ...session.user,
    jwt: session.token,
    isDemo: false,
  };

  localStorage.setItem("jwt", session.token);
  useAuthStore.getState().setAuth(user, session.token);
  registerExtensionSession(session.token);
  return user;
}
